import { API_URL } from "./config";
import axios from "axios";

export const generateScrutinizedWord = async (
  risk_assesmnt_id: number,
  word_index: number,
  occurence_index: number,
  payload: any
): Promise<any> => {
  try {
    const response = await axios.post(
      `${API_URL}/scrutinizedword/rephrase/${risk_assesmnt_id}/${word_index}/${occurence_index}/generate`, payload
    );

    return response.data;
  } catch (error: any) {
    console.error("Error fetching scrutinized word :", error.response?.data || error.message);
    throw error;
  }
};

export const getAllScrutinizedWord = async (
  risk_assesmnt_id: number,
  word_index: number,
  occurence_index: number,
): Promise<any> => {
  try {
    const response = await axios.get(
      `${API_URL}/scrutinizedword/rephrase/${risk_assesmnt_id}/${word_index}/${occurence_index}`,
    );

    return response.data;
  } catch (error: any) {
    console.error("Error fetching scrutinized word list:", error.response?.data || error.message);
    throw error;
  }
};

export const deleteScrutinizedWords = async (
  payload: any,
): Promise<any> => {
  try {
    const response = await axios.post(
      `${API_URL}/scrutinizedword/rephrase/delete`, payload
    );

    return response.data;
  } catch (error: any) {
    console.error("Error while deleting scrutinized word :", error.response?.data || error.message);
    throw error;
  }
};

export const generateBulkScrutinizedWord = async (
  risk_assesmnt_id: number,
  word_index: number,
): Promise<any> => {
  try {
    const response = await axios.post(
      `${API_URL}/scrutinizedword/rephrase/${risk_assesmnt_id}/${word_index}/bulk-generate`,
    );

    return response.data;
  } catch (error: any) {
    console.error("Error while deleting scrutinized word :", error.response?.data || error.message);
    throw error;
  }
};

// scrutinizedword/rephrase/<int:analysis_response_id>/<int:word_index>/bulk-generate

export const getAllScrutinizedWordList = async (
  risk_assesmnt_id: number,
  word_index: number,
): Promise<any> => {
  try {
    const response = await axios.get(
      `${API_URL}/scrutinizedword/rephrase/${risk_assesmnt_id}/${word_index}`,
    );

    return response.data;
  } catch (error: any) {
    console.error("Error fetching scrutinized word list:", error.response?.data || error.message);
    throw error;
  }
};